import SEOMeta from '@/components/feature/SEOMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutContent } from '@/mocks/data';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于性欲社',
  description: '性欲社是专注于两性健康、亲密关系与性福教育的权威平台。了解我们的品牌故事、核心价值和专业团队。',
  about: {
    '@type': 'Organization',
    name: '性欲社',
    foundingDate: '2024',
    description: '专注于两性健康知识与亲密关系指南的权威平台',
  },
};

export default function AboutPage() {
  return (
    <>
      <SEOMeta
        title="关于我们 - 性欲社"
        description="了解性欲社的品牌故事、核心价值与专业团队。我们致力于用科学与温度，点亮每个人的性福之路。"
        keywords="性欲社,关于我们,品牌介绍,两性健康,性教育平台"
        canonicalUrl="https://sportsix.github.io/about"
      />

      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>

      <main className="pt-24 pb-16 min-h-screen">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            {/* Breadcrumb */}
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />

            {/* Page Header */}
            <div className="mt-8 mb-12">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
                关于性欲社
              </h1>
              <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl">
                用科学与温度，点亮每个人的性福之路
              </p>
            </div>

            {/* Stats Bar */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
              {aboutContent.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center"
                >
                  <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.number}
                  </p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>

            {/* Brand Story */}
            <section className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
                品牌故事
              </h2>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                {aboutContent.brandStory.split('\n\n').map((para, idx) => (
                  <p
                    key={idx}
                    className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 last:mb-0"
                  >
                    {para}
                  </p>
                ))}
                <div className="mt-6 pt-4 border-t border-background-200/70">
                  <p className="text-base md:text-lg font-heading font-semibold text-primary-500 italic">
                    "{aboutContent.mission}"
                  </p>
                </div>
              </div>
            </section>

            {/* Core Values */}
            <section className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
                核心价值
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {aboutContent.values.map((value) => (
                  <div
                    key={value.title}
                    className="bg-background-50 border border-background-200/70 rounded-lg p-6 flex gap-4"
                  >
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                      <i className={`${value.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900">
                        {value.title}
                      </h3>
                      <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Team */}
            <section className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
                核心团队
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {aboutContent.team.map((member) => (
                  <div
                    key={member.name}
                    className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center"
                  >
                    <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                      <i className="ri-user-3-line text-2xl text-accent-500"></i>
                    </div>
                    <h3 className="mt-4 text-sm md:text-base font-heading font-semibold text-foreground-900">
                      {member.name}
                    </h3>
                    <p className="mt-1 text-xs text-accent-500 font-medium">
                      {member.title}
                    </p>
                    <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {member.description}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section id="contact" className="mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
                联系我们
              </h2>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">邮箱</p>
                      <p className="mt-1 text-sm text-foreground-500">contact@xingyushe.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">微信公众号</p>
                      <p className="mt-1 text-sm text-foreground-500">搜索"性欲社"</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                      <i className="ri-question-answer-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">合作咨询</p>
                      <p className="mt-1 text-sm text-foreground-500">partners@xingyushe.com</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8 pt-6 border-t border-background-200/70">
                  <p className="text-sm text-foreground-500">
                    <strong className="text-foreground-700">投稿与合作：</strong>
                    我们欢迎具有相关专业背景的作者加入。如果你是医生、心理咨询师、性教育工作者或相关领域的研究者，请通过上述邮箱联系我们，附上你的个人简介和作品样例，我们会在3个工作日内回复。
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}